import React, { useState } from "react";
import { Link } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const WeOffer = () => {
  const [isVisible, setIsVisible] = useState(false);

  const sessionType = [
    { type: "Mock Interview" },
    { type: "Interview prep & tips" },
    { type: "Career guidance" },
    { type: "1:1 Mentorship" },
    { type: "Resume Review" },
    { type: "Quick call" },
  ];

  return (
    <>
      <h1 className="text-center bg-bisque pt-16 text-3xl font-bold">
        What we offer?
      </h1>
      <div className="flex flex-wrap justify-center gap-10 pt-20 pb-28 px-8 bg-bisque">
        {sessionType.map((val, index) => {
          return (
            <div id="Services"
              className="bg-white p-6 rounded-2xl flex flex-col gap-8 shadow-md max-w-sm"
              key={index}
            >
              <div className="text-lg font-bold">{val.type}</div>
              <div className="flex items-center justify-between bg-gray-100 p-4 rounded-2xl gap-2">
                <div className="flex items-center gap-2 font-bold">
                  <CalendarMonthIcon /> Video Meeting
                </div>
                <Link to={"/mentors-list"} className="primary-btn ">
                  Book Slot
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default WeOffer;
